const { View } = require('react-native');

const DatePicker = () => {
  return <View />;
};

export default DatePicker;
